module.exports = __webpack_public_path__ + "media/images/shared/member-icon-white-8ab8273a39123c8777f872af9bcf6fec.png";